// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPage-cls1_baI","cls2":"EvaluationPage-cls2_9gF EvaluationPage-cls1_baI"};